<template>
	<div class="bottom-adr">
		<div class="bottom-wrapper">
			<router-link to="/brightmain">
				<span class="bottom-word">{{bottomWord[0]}}</span>
			</router-link>
			<router-link to="/aboutUs">
				<span class="bottom-word">{{bottomWord[1]}}</span>
			</router-link>
			<!-- <router-link to="/help">
				<span class="bottom-word">{{bottomWord[2]}}</span>
			</router-link> -->
			<router-link to="/linkUs">
				<span class="bottom-word">{{bottomWord[3]}}</span>
			</router-link>
			<router-link to="/brightmain">
				<span class="bottom-word lang"  @click="changeLangEvent">{{bottomWord[4]}}</span>
			</router-link>
		</div>
		<span class="bottom-fine-word">Copyright@2018壮景化工 All Right Reserved 沪IPC备09000000 公安机关备案号：31011502002000</span>
	</div>
</template>

<script type="text/ecmascript-6">
import { setup } from "../../main.js"

export default {
	data() {
		return {
		}
	},
	methods: {
		changeLangEvent() {
			if(this.$i18n.locale === 'zh') {
				 setup('en')
			} else {
				 setup('zh')
			}
			// setup(lang)
			this.$emit('changeToEnglish')
		}
	},
	computed: {
		bottomWord() {
			return this.$t("bottomWord")
		}
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.bottom-adr
		position: relative
		width: 100%
		height: 60px
		background: $color-theme
		@media screen and (max-width:550px)
			position: absolute
			bottom: 0
			height: 50px
		.bottom-wrapper
			float: right
			height: 20px
			margin: 5px 20px
			.bottom-word
				font-size: $font-web-small-s
				color: $color-text
				padding: 0 10px
				border-right: 1px solid $color-text
			.lang
				border: none 
		.bottom-fine-word
			position: absolute
			bottom: 5px
			right: 30px
			font-size: $font-web-small-ss
			color: $color-text-m
			@media screen and (max-width:550px)
				font-size: 0.35rem
</style>



// WEBPACK FOOTER //
// src/components/bottom-adr/bottom-adr.vue